import { useState } from 'react';

export function useModalState() {
  const [activeModal, setActiveModal] = useState(null);
  const openModal = name => setActiveModal(name);
  const closeModal = () => setActiveModal(null);
  const modalProps = name => ({
    visible: activeModal === name,
    onCancel: closeModal,
  });
  return { activeModal, openModal, closeModal, modalProps };
}
